import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import BreadCrumb from "./BreadCrumb";
import HeaderView from "./HeaderView";
import FooterView from "./FooterView";
import { MyColor } from "../config/myStyle";
import { campaignThemeStore, userStore } from "../stores";

const MainLayout = observer(() => {
  useEffect(() => {
    if (!campaignThemeStore.campaignThemeDataList?.items?.length) {
      campaignThemeStore.getCampaignThemeList({
        limit: 1000,
        locale: userStore.language,
      });
    }
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: MyColor.bg,
      }}
    >
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          maxWidth: 800,
        }}
      >
        <div
          className="flex min-h-screen flex-col pt-[102px]"
          style={{
            backgroundColor: MyColor.bg,
            minHeight: "100%"
          }}
        >
          <div
            style={{
              position: 'fixed',
              width: '100%',
              zIndex: 100,
              top: 14,
              left: '50%',
              transform: 'translateX(-50%)',
              maxWidth: 800,
            }}
          >
            <HeaderView />
          </div>
          <BreadCrumb />
          <div className="flex-1" style={{ position: 'relative' }}>
            <Outlet />

          </div>
          <FooterView />
        </div>
      </div>

    </div>

  );
});
export default MainLayout;
